import { Decimal } from 'decimal.js'
export const toAmountCNYStr = (amount: any): string => {
    const num = Number(amount) || 0;
    return num.toLocaleString("zh-CN", {
        style: "currency",
        currency: "CNY",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });
}
export const add = (a: number, b: number, place = 1) => {
    const result = new Decimal(a).plus(new Decimal(b));
    return result.toDecimalPlaces(place).toNumber(); // 保留一位小数
}

export const addMultiple = (place: number = 1, ...numbers: number[]): number => {
    const result = numbers.reduce((acc, num) => acc.plus(new Decimal(num)), new Decimal(0));
    return result.toDecimalPlaces(place).toNumber();
}
export const oneDecimals = (a: number) => {
    return Number(Number(a).toFixed(1))
}
export const formatAmount = (amount: any) => {
    if(!amount) return amount
    // 确保输入是数字
    if (typeof amount !== 'number') {
        amount = Number(amount) || 0;
    }

    // 大于10000时转为"万"单位
    if (Math.abs(amount) >= 10000) {
        return (amount / 10000).toFixed(2) + '万';
    }

    // 小于10000时返回原数字，保留两位小数
    return amount.toFixed(2);
}